/**
 * Dashboard Tour Steps
 * Main onboarding tour for AMS dashboard
 * Based on recommendations from react-joyride.md
 */
import { Step } from "react-joyride";

export const dashboardSteps: Step[] = [
  {
    target: "body",
    content:
      "Welcome to your Agency Management Dashboard! Let's take a quick tour of the key features to help you get started.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tour="emails-nav"]',
    content:
      "The emails tab is where you can set up powerful email automations and email templates to help your onboarding and recruiting process simple!",
    placement: "right",
  },
  {
    target: '[data-tour="analytics-nav"]',
    content:
      "The analytics page shows data from Find My Agency and AMS. Check it out!",
    placement: "right",
  },
  {
    target: '[data-tour="dashboard-stats"]',
    content:
      "These metrics show your organization's current totals at a glance: total agents, active agencies, clients, and annual premium.",
    placement: "bottom",
  },
  {
    target: '[data-tour="quick-actions"]',
    content:
      "Use Quick Actions to rapidly add agents, agencies, or clients. The Analytics button shows performance charts.",
    placement: "bottom",
  },
  {
    target: '[data-tour="interview-bookings"]',
    content:
      "Here, you will find all of your interviews from Find My Agency and auto inserted into your account for easy tracking. You can also click on their account to see their profile page in depth.",
    placement: "top",
  },
  {
    target: '[data-tour="recent-activity"]',
    content:
      "Track recent activities and changes in your organization here. This helps you stay informed about what's happening across your team.",
    placement: "top",
  },
  {
    target: '[data-tour="tasks"]',
    content:
      "Manage your to-do list and keep track of important follow-ups. Tasks help you stay organized and ensure nothing falls through the cracks.",
    placement: "top",
  },
  {
    target: "body",
    content:
      "That's it! You're ready to start managing your agency. Navigate to Agents, Agencies, or Clients to see page-specific tours. You can restart this tour anytime from Settings.",
    placement: "center",
  },
];
